import { render } from "./LoggedView.vue?vue&type=template&id=0ef73a40&ts=true"
import script from "./LoggedView.vue?vue&type=script&lang=ts"
export * from "./LoggedView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\benja\\Desktop\\Renault\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__